import React, { useState, useEffect } from 'react'
import { Card, Button } from '../primitives';
import { catchErrorParse } from '../../ErrorUtility';
import { useAuthPost } from '../../hooks/useAxios';
import { useAuth } from '../../contexts/AuthContext';
import { useTranslation } from '../../hooks/useTranslation';
import Refresh from '../primitives/Refresh';
import { useOutletContext } from 'react-router-dom';
import Modal from '../portals/Modal';

export default function CustomerBalance({ stripeCustomerId }) {
    const [refreshing, setRefreshing] = useState(false);
    const [showCheckmark, setShowCheckmark] = useState(false);
    const { balance, getBalance } = useOutletContext();

    const [refundLoading, setRefundLoading] = useState(false);
    const [isOpen, setIsOpen] = useState(false);

    const { post } = useAuthPost();
    const { url } = useAuth();
    const t = useTranslation();

    const fetchBalance = async () => {
        setRefreshing(true);
        await getBalance();
        setShowCheckmark(true);
        setTimeout(() => {
            setRefreshing(false);
            setShowCheckmark(false);
        }, 10000);
    };

    const requestRefund = async () => {
        setRefundLoading(true);
        const [result, error, errorCode, errorMessage] = await catchErrorParse(post, `${url}/webapp/balance/refund`, {
            stripeCustomerId,
        });
        if (error) {
            window.dispatchEvent(new CustomEvent('masterError', {
                detail: {
                    code: errorCode,
                    message: errorMessage ? errorMessage : error.message
                }
            }));
        } else {
            fetchBalance();
            setIsOpen(false);
        }
        setRefundLoading(false);
    };

    useEffect(() => {
        if (stripeCustomerId) {
            getBalance();
        }
    }, [stripeCustomerId]);

    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
        }).format(amount); // Stripe amounts are in cents
    };

    return (
        <>
        <Card className='margin-bottom'>
            <Card.Header>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <h2 style={{ margin: 0 }}>{t('Account Balance: ')}<span style={{ color: balance <= 0 ? '#27ca52' : '#ca2727' }}>{formatCurrency(balance)}</span></h2>
                    <Refresh handleRefresh={fetchBalance} showCheckmark={showCheckmark} refreshing={refreshing} />
                </div>
            </Card.Header>
            <Card.Body>
                <div className="balance-container">
                    <p>{t('This is your account\'s current credit balance.')}</p>
                    {balance < -5 && <Button className="settings" onClick={() => setIsOpen(true)} loading={refundLoading} disabled={refreshing}>
                        {t('Request Refund')}
                    </Button>}
                </div>
            </Card.Body>
        </Card>
        <Modal open={isOpen} onClose={() => setIsOpen(false)} lock={refundLoading}>
            <Card className='white'>
                <Card.Header>
                    <h2>{t('Request Refund')}</h2>
                </Card.Header>
                <Card.Body>
                    <p style={{ textAlign: 'center' }}>{t('Refunds can be payed out from multiple previous charges.')}</p>
                    <p style={{ textAlign: 'center' }}>{t('Refunds typically take 5 to 10 business days.')}</p>
                    <Button className="submit" onClick={requestRefund} loading={refundLoading} disabled={refreshing}>
                        {t('Request Refund')}
                    </Button>
                    <Button onClick={() => setIsOpen(false)}>
                        {t('Cancel')}
                    </Button>
                </Card.Body>
            </Card>
        </Modal>
        </>
    )
}